<div class="qa-grid mm-page">
  <h2 class="mb-4">{{_(KEYS.LICENSE_MANAGER.GRID.LICENSES)}}</h2>
  <div class="card mb-5">
    <div class="card-body">
      <button type="button" class="card-title mm-pane-toggle"
              (click)="isSearchCollapsed = !isSearchCollapsed"
              [attr.aria-expanded]="!isSearchCollapsed" aria-controls="license-manager-grid-search-fields">
        <span class="mm-pane-toggle-label">
          <i class="fa fa-search" aria-hidden="true"></i>
          <span>{{_(KEYS.LICENSE_MANAGER.GRID.SEARCH)}}</span>
        </span>
        <span class="mm-pane-toggle-icon" aria-hidden="true">
          <i class="fa" [ngClass]="{'fa-chevron-down': isSearchCollapsed, 'fa-chevron-up': !isSearchCollapsed}"></i>
        </span>
      </button>
      <div id="license-manager-grid-search-fields" class="card-text" [ngbCollapse]="isSearchCollapsed">
        <div class="qa-grid-search mt-2 mb-2">
          <div class="input-group qa-grid-search-name">
            <span class="input-group-addon">{{_(KEYS.DEFAULT.LICENSEE)}}:</span>
            <input class="form-control" [(ngModel)]="filter.name"
                   (paste)="onFilterChange()" (change)="onFilterChange()" (keydown)="onFilterChange()">
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <button type="button" class="card-title mm-pane-toggle"
                (click)="isGridCollapsed = !isGridCollapsed"
                [attr.aria-expanded]="!isGridCollapsed" aria-controls="license-manager-grid-results">
          <span class="mm-pane-toggle-label"><i class="fa fa-copy" aria-hidden="true"></i><span>{{_(KEYS.LICENSE_MANAGER.GRID.LICENSES)}}</span></span>
          <span class="mm-pane-toggle-icon" aria-hidden="true">
            <i class="fa" [ngClass]="{'fa-chevron-down': isGridCollapsed, 'fa-chevron-up': !isGridCollapsed}"></i>
          </span>
        </button>
      <div id="license-manager-grid-results" class="card-text" [ngbCollapse]="isGridCollapsed">
        <div class="mm-table-scroll"><table class="table">
          <thead>
          <tr>
            <th class="id-col">{{_(KEYS.LICENSE_MANAGER.GRID.ID)}}</th>
            <th>{{_(KEYS.DEFAULT.LICENSEE)}}</th>
            <th>{{_(KEYS.DEFAULT.PARTNER)}}</th>
            <th>{{_(KEYS.LICENSE_MANAGER.GRID.OPTIONS)}}</th>
            <th>{{_(KEYS.LICENSE_MANAGER.GRID.VALID_UNTIL)}}</th>
            <th>{{_(KEYS.LICENSE_MANAGER.GRID.CREATED_BY)}}</th>
            <th>{{_(KEYS.LICENSE_MANAGER.GRID.UPDATED_BY)}}</th>
            <th>{{_(KEYS.LICENSE_MANAGER.GRID.CREATED_AT)}}</th>
            <th>{{_(KEYS.LICENSE_MANAGER.GRID.UPDATED_AT)}}</th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngFor="let license of licenses; let pos = index;">
            <tr [ngClass]="{'qa-tr-odd': pos % 2 === 0}">
              <td class="id-col">
                <span ngbTooltip="{{license.id}}">{{license.id | truncate: 5}}</span>
              </td>
              <td>
                {{license.name}}
              </td>
              <td>
                {{license.partner || 'myMedax'}}
              </td>
              <td>
                <button class="btn btn-sm btn-primary" (click)="onOpenLicense(license)" *ngIf="!isUnlocked">
                  <i class="fa fa-info-circle"></i>
                </button>

                <button class="btn btn-sm btn-primary" (click)="onOpenLicense(license)" *ngIf="isUnlocked">
                  <i class="fa fa-edit"></i>
                </button>

                <button class="btn btn-sm btn-danger ml-1" (click)="onDeleteLicense(license)" *ngIf="isUnlocked">
                  <i class="fa fa-trash"></i>
                </button>
              </td>
              <td style="min-width: 135px;">
                {{license.validUntil | datex:dateFormatYMD}}
              </td>
              <td>
                {{license.createdBy || '?'}}
              </td>
              <td>
                {{license.updatedBy || '?'}}
              </td>
              <td style="min-width: 135px;">
                {{license.createdAt | datex:dateFormat}}
              </td>
              <td style="min-width: 135px;">
                {{license.updatedAt | datex:dateFormat}}
              </td>
            </tr>
          </ng-container>
          </tbody>
        </table></div>
        <div class="btn-toolbar justify-content-between mt-2 mb-2">
          <div class="justify-content-between">
            <div class="input-group">
              <div class="input-group qa-num-per-page">
                <select class="form-control custom-select" [(ngModel)]="displayPerPage" (change)="onPagingChange()">
                  <option value="2">2</option>
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
                <span class="input-group-addon">{{_(KEYS.LICENSE_MANAGER.GRID.ENTRIES)}}</span>
              </div>

              <button
                class="btn btn-primary ml-1"
                (click)="onCreateLicense()"
                data-toggle="tooltip"
                data-placement="top"
                title="Lizenz erstellen"
                [attr.disabled]="isUnlocked ? null: true">
                <i class="fa fa-plus"></i>
              </button>
            </div>
          </div>
          <ngb-pagination
            [pageSize]="displayPerPage"
            [maxSize]="9"
            [rotate]="true"
            [(page)]="gridPageNumber"
            [collectionSize]="total"
            (pageChange)="onPagingChange()">
          </ngb-pagination>
        </div>
      </div>
    </div>
  </div>

  <br>
  <div *ngIf="!isPubKeyMode">
    <div class="input-group" style="width: 250px;" *ngIf="!isUnlocked">
      <input type="password" class="form-control" placeholder="Entsperren..." [(ngModel)]="keyPassword">
      <button class="btn btn-primary" type="button" (click)="onUnlock()">
        <i class="fa fa-lock"></i>
      </button>
    </div>

    <div class="input-group" style="width: 250px;" *ngIf="isUnlocked">
      <button class="btn btn-primary" type="button" (click)="onLock()">
        Entsperrt
        <i class="fa fa-unlock"></i>
      </button>
    </div>
  </div>
</div>
